module.exports = __webpack_public_path__ + "static/media/lithonia-family-planning doctor.b16352ff.png";